import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { PalletCapacity } from "../pallet-capacity/pallet-capacity.entity";
import { Uoms } from "../uoms/uom.entity";
import { FgpriceList } from "../fg-pricelist/fg-pricelist-entity";
import { PackingMaterialPricesEntity } from "../packing-material-prices/packing-material-prices-entity";

@Entity('packing_methods')
export class PackingMethod {

  @PrimaryGeneratedColumn("increment",{name:'packing_method_id'})
  packingMethodId:number;
 
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"packing_method_name"
      })
      // @Index({ unique: true })
      packingMethodName:string;

    @Column("int",{
      nullable:false,
      name:"no_of_pouches"
      })
      noOfPouches:number;

    @Column({
      type: 'decimal', precision: 10, scale: 3,
      nullable:false,
      name:"pouches_per_row"
      })
    pouchesPerRow:number;
    @Column("int",{
      nullable:true,
      name:"uom_id"
      })
      uomId:number;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  
  @Column("int",{
    nullable:false,
    default:true,
    name:"pallet_capacity"
    })
  palletCapacity:number;

  @Column("int",{
    nullable:false,
    default:true,
    name:"max_pallet_capacity"
    })
  maxPalletCapacity:number;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @Column({
    type: 'decimal', precision: 10, scale: 3,
    nullable:false,
    name:"gross_weight"
    })
  grossWeight:number;
 
  @ManyToOne(type => Uoms, uom => uom.itemInfo, { nullable: true, })
  @JoinColumn({ name: "uom_id" })
  uomInfo: Uoms;
  @OneToMany(type => PalletCapacity, palletCapacity => palletCapacity.packingMethodInfo)
  palletCapacityInfo: PalletCapacity[];
//   @OneToMany(type => FgpriceList, palletCapacity => palletCapacity.packingStyleId)
//   fgPriceInfo: FgpriceList[];
  @OneToMany(type => PackingMaterialPricesEntity, palletCapacity => palletCapacity.packingStyleId)
  packingMaterialInfo: PackingMaterialPricesEntity[];
}

